import {useEffect} from 'react';
import {Platform} from 'react-native';

const LOCALE_MAP: Record<string, string> = {
  en: 'en_US',
  de: 'de_DE',
};

const BASE_URL = 'https://app.omas-app.com';

/**
 * Sets document.title, meta description, canonical, OG/Twitter tags, and html lang on web.
 * No-op on native.
 */
export function useDocumentMeta(
  title: string,
  description?: string,
  locale?: string,
  path?: string,
) {
  useEffect(() => {
    if (Platform.OS !== 'web') return;

    document.title = title;

    if (description) {
      setMeta('meta[name="description"]', 'content', description);
      setMeta('meta[property="og:description"]', 'content', description);
      setMeta('meta[name="twitter:description"]', 'content', description);
    }

    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[name="twitter:title"]', 'content', title);

    // Update canonical URL and og:url based on current page
    const canonicalUrl = `${BASE_URL}${path ?? window.location.pathname}`;
    setLink('link[rel="canonical"]', 'href', canonicalUrl);
    setMeta('meta[property="og:url"]', 'content', canonicalUrl);

    if (locale) {
      document.documentElement.lang = locale;
      const ogLocale = LOCALE_MAP[locale] || locale;
      setMeta('meta[property="og:locale"]', 'content', ogLocale);
    }
  }, [title, description, locale, path]);
}

function setMeta(selector: string, attr: string, value: string) {
  const el = document.querySelector(selector);
  if (el) {
    el.setAttribute(attr, value);
  }
}

function setLink(selector: string, attr: string, value: string) {
  const el = document.querySelector(selector);
  if (el) {
    el.setAttribute(attr, value);
  }
}
